import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import { useNavigate, useParams } from "react-router-dom";
import HrmsJodOffer from "./HrmsJodOffer";

const HrmsApproveConnectivity = () => {
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive,
    );
    const dispatch = useDispatch();
    const state = useSelector((state) => state);
    const navigate = useNavigate();
    const { emoloyeeId } = useParams();

    const rawData = state?.hrmsConnectivityList?.hrmsConnectivityListData;

    const currentEmp = useMemo(() => {
        if (Array.isArray(rawData) && rawData.length > 0) {
            return rawData.find((el) => String(el?.id) === String(emoloyeeId) || String(el?.user_id?.id) === String(emoloyeeId)) || (rawData.length === 1 ? rawData[0] : null);
        } else if (rawData && typeof rawData === "object" && !Array.isArray(rawData)) {
            return rawData;
        }
        return null;
    }, [rawData, emoloyeeId]);

    const firstName = currentEmp?.basic_info?.first_name || "";
    const lastName = currentEmp?.basic_info?.last_name || "";

    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div
                    className="Header-Details ClientBranch row"
                    style={{ padding: "14px 28px" }}
                >
                    <div
                        className="col-sm-7 auto"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                        }}
                    >
                        <h3 className="user-name mb-0">HRMS Connectivity</h3>
                        <br />
                    </div>
                    <div>
                        <div
                            className="InnerDetailPart"
                            style={{
                                display: "flex",
                                gap: "20px",
                                background: "rgb(255, 223, 213)",
                                padding: "20px 10px 0px",
                                borderRadius: "5px",
                                marginBottom: "5px",
                            }}
                        >
                            <div className="">
                                <button
                                    className=""
                                    style={{
                                        padding: "3px 7px",
                                        background: "rgb(239, 77, 57)",
                                        color: "white",
                                        fontSize: "15px",
                                        borderRadius: "6px",
                                    }}
                                    onClick={(e) => {
                                        navigate("/hrmsconnectivity");
                                    }}
                                >
                                    {"Back"}
                                    <span></span>
                                </button>
                            </div>
                            <div className="LOGO" style={{ width: "25px", height: "25px" }}>
                                <img src={profile2} style={{ width: "25px", height: "25px" }} alt="profile" />
                            </div>
                            <p className="EMpCODER">
                                <span>
                                    {firstName} {lastName}
                                </span>
                            </p>
                        </div>
                        <HrmsJodOffer />
                    </div>
                </div>
            </div>
        </>
    );
};

export default HrmsApproveConnectivity;